import type { paths } from '@pba/types-openapi-node';
import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type DeleteEventParams = paths['/events/{id}']['delete']['parameters']['path'];
type DeleteEventResponse = paths['/events/{id}']['delete']['responses']['200']['content']['application/json'];

export const deleteEvent = async ({ routeParams: { id } }: RouteParamsRequest<DeleteEventParams>) =>
  nodeApiClient.delete<DeleteEventResponse, ApiClientResponse<DeleteEventResponse>>(nodeApiRoutes.events.delete(id));
